<template>
  <v-container class="dragContainer">
    <v-card justify="center" id="dropzone" @click="$refs.image.click()" flat>
      <input
        type="file"
        style="display: none"
        ref="image"
        accept="image/*"
        @change="onFilePicked"
      />
      <v-img v-if="imageSrc" :src="imageSrc" aspect-ratio="1.67" class="float ma-1"> </v-img>
      <v-container class="text-center">
        <div v-if="!imageSrc">
          <h2 class="mt-2">{{ title }}</h2>

          <h4 class="primary--text mt-2">
            <v-icon large class="mr-3 primary--text">mdi-cloud-upload</v-icon>
            {{ $t("base.DragAndDrop.uploadHolder") }}
          </h4>
          <small>{{ $t("base.DragAndDrop.small") }}</small>
          <br />
        </div>
        <ImageGallery @url="imageObtained" />
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import resizeImage from "@/plugins/image-resize.js";
import ImageGallery from "./ImageGallery";

const reader = new FileReader();

export default {
  name: "DragAndDrop",
  props: ["title", "height", "initial"],
  components: {
    ImageGallery,
  },
  data() {
    return {
      uploadedFiles: [],
      isHovering: false,
      counter: 0,
      defaultHeight: 200,
      imageSrc: null,
    };
  },
  computed: {
    cardColor() {
      return this.isHovering ? "deep-purple" : "transparent";
    },
  },
  watch: {
    initial(newVal) {
      console.log("drag and drop, initial changed1!!!!", newVal);
      if (newVal) {
        this.loadInitialImage(newVal);
      }
    },
  },

  methods: {
    loadInitialImage(src) {
      if (src.includes("/")) {
        this.imageSrc = src;
      } else {
        const cityImages = {};
        Object.values(this.$store.state.trip.cities).forEach((city) => {
          const imageUrl = city.image;
          let imageName;

          if (imageUrl.includes("wikimedia")) {
            imageName = `${city.wiki_code}.${imageUrl.split(/[#?]/)[0].split(".").pop().trim()}`;
          } else {
            imageName = imageUrl.substring(imageUrl.lastIndexOf("/") + 1);
          }
          cityImages[imageName] = imageUrl;
        });
        if (cityImages[src] != null) {
          this.imageSrc = cityImages[src];
          return;
        }
        // eslint-disable-next-line import/no-dynamic-require
        this.imageSrc = require(`@/assets/img/${src}.jpg`);
      }
    },
    imageObtained(image) {
      console.log("url obtained");
      this.imageSrc = image.url;
      this.$emit("imagepath", image.path);
      this.$emit("update:file", null);
    },
    async onFilePicked(e) {
      const { files } = e.target;
      if (files && files[0] !== undefined) {
        const resizedImageFile = await resizeImage({ file: files[0] });
        this.$emit("update:file", resizedImageFile);

        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.$emit("imagepath", null);
          // this.$emit("update:file", files[0]);
          this.imageSrc = fr.result;
        });
      }
    },
  },
  mounted() {
    console.log("DragAndDrop Mounted!!!", this.$props.initial);
    if (this.$props.initial) {
      this.loadInitialImage(this.$props.initial);
    }
    console.log("registering for drop events");
    const self = this;
    window.addEventListener("dragenter", () => {
      self.isHovering = true;
      self.counter += 1;
      console.log("isHOvering->", self.isHovering);
    });

    window.addEventListener("dragleave", (e) => {
      e.preventDefault();

      self.counter -= 1;
      if (self.counter === 0) {
        self.isHovering = false;
        console.log("dragLeave->", self.isHovering);
      }
    });

    window.addEventListener("dragover", (e) => {
      e.preventDefault();
    });

    window.addEventListener("drop", async (e) => {
      e.preventDefault();

      const file = e.dataTransfer.files[0];
      console.log("Drop files:", file);
      const resizedImageFile = await resizeImage({ file });
      self.$emit("update:file", resizedImageFile);
      reader.addEventListener(
        "load",
        () => {
          self.imageSrc = reader.result;
        },
        false,
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    });
  },
};
</script>

<style>
.dragContainer {
  background-color: #f5f6fa;
}

#dropzone {
  background-color: #f5f6fa;
  border-style: dashed;
  border-width: 2px;
  border-color: var(--v-primary-base);
}

.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
}
</style>
